import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { msLeaveUrlServer } from 'src/app/global_constants';

@Injectable({
  providedIn: 'root'
})
export class LeaveService {

  createLeaveSubject:Subject<any>;
  leaveListSubject:Subject<any>;
  updateLeaveSubject:Subject<any>;
  leaveSubject:Subject<any>;
  baseUrl = msLeaveUrlServer.concat("/leave/v1/leave");
  token:any;

  constructor(
    private httpClient:HttpClient
    ) {
      this.createLeaveSubject = new Subject();
      this.leaveListSubject = new Subject();
      this.updateLeaveSubject = new Subject();
      this.leaveSubject = new Subject();

      
      this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
     }

  
  createLeave(reqBody : any) {
    this.createLeaveSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.post(this.baseUrl, reqBody, {headers: header}).subscribe((response: any) => {
        this.createLeaveSubject.next(response);
        this.createLeaveSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getLeaveList() {
    this.leaveListSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.get(this.baseUrl, {headers: header}).subscribe((response: any) => {
        this.leaveListSubject.next(response);
        this.leaveListSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getLeave(uuid: any) {
    this.leaveSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.get(this.baseUrl+'/'+uuid, {headers: header}).subscribe((response: any) => {
        this.leaveSubject.next(response);
        this.leaveSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  
  updateLeave(reqBody:any, action:any) {
    this.updateLeaveSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.patch(this.baseUrl+"/"+action, reqBody, {headers: header}).subscribe((response: any) => {
        this.updateLeaveSubject.next(response);
        this.updateLeaveSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  
}
